import {dbParent} from './utils';
import firebase from "firebase";
import _ from "lodash";

export const createUser = (project_id, user_data) => {
  return dbParent('projects').doc(project_id).collection('users')
    .add(user_data);
}

export const getRole = async (id) => {
  const users = await myFirestore
    .collection('projects')
    .doc(id)
    .collection('users')
    .where('uid', '==', authFirestore.currentUser.uid)
    .get();

  let role = null;

  await users.forEach((sub) => {
    const data = sub.data();
    if (data) {
      role = data.role;
    }
  });

  return role;
}

export const getUsersOptions = async (id, ignoreAll = false, blockId = false) => {
  const result = [];

  if(!ignoreAll) {
    result.push({label: 'Все пользователи', value: null})
  }

  const data = await myFirestore
    .collection('projects')
    .doc(id)
    .collection('users')
    .get();

  await data.forEach((subDoc) => {
    let _data = subDoc.data();
    if(blockId) {
      result.push({label: _data.name || _data.email, value: subDoc.id, _data: _data});

    } else {
      result.push({label: _data.name || _data.email, value: _data.uid || subDoc.id, _data: _data});
    }
  });

  return _.uniqBy(result, 'value');
}

export const getCompaniesOptions = async (id, blockId = false) => {
  const result = [];

  const data = await myFirestore
    .collection('projects')
    .doc(id)
    .collection('users')
    .where('isCompany', '==', true)
    .get();

  await data.forEach((subDoc) => {
    let _data = subDoc.data();
    if(blockId) {
      result.push({label: _data.name || _data.email, value: subDoc.id, _data: _data});

    } else {
      result.push({label: _data.name || _data.email, value: _data.uid || subDoc.id, _data: _data});
    }
  });

  return _.uniqBy(result, 'value');
}



// WEBPACK FOOTER //
// ./src/firestore/users.js